/**
 * Number of message preview lines shown in the message list.
 *
 * `Off` means no preview text is shown. `OneLine` and `TwoLines` are the literal
 * number of preview lines rendered in both the single-line (MCL) and multi-line
 * (SCL) list views.
 *
 * `Inline` is a sentinel for the MCL-only "Inline" option, where the preview is
 * rendered on the same row as the subject instead of on its own line(s). It is
 * only selectable in MCL; in SCL it is resolved to `Off` for display.
 *
 * The numeric values are persisted to the service (OCS `mail_showpreviewlinesinlistview`),
 * so they must remain stable.
 */
export enum PreviewLinesOption {
    Off = 0,
    Inline = -1,
    OneLine = 1,
    TwoLines = 2
}
